<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3> {{ mainTitle }} </h3>
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
            <b-col cols="12">
              <hr />
            </b-col>
            <b-col cols="12">
              <form-select
                ref="formStart"
                rules="required"
                label="العضو الذي سيتم التعديل عليه"
                id="director_board_year"
                v-model="form.old_director_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name"
                ep="v2/selects/directors"
                
              />
            </b-col>
            <b-col cols="12">
              <form-textarea
                class="my-1"
                label="سبب التعديل"
                rules="required"
                v-model="form.switching_reason"
              />

            </b-col>
            
            <b-col cols="12">
              <form-select
                rules="required"
                label="رقم المحضر"
                id="meeting_minute"
                v-model="form.meeting_minute_id"
                :getOptionLabel="(x) => x.meeting_minutes_label"
                :reduce="(x) => x"
                ep="v2/selects/meeting-minutes"
              />
              
              <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
                في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
              </small>
            </b-col>
            <b-col  cols="12 mt-2">
              معلومات العضو الجديد
              <hr />
            </b-col>
            <b-col cols="12">
              <form-input
                label="الاسم الكامل"
                v-model="form.name"
                rules="required"
              />

            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="المؤهل العلمي"
                id="qualification_id"
                v-model="form.qualification_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.title"
                ep="v2/selects/qualifications"
                
              />
            </b-col>
            <b-col cols="12">
              <form-select
                label="الصفة"
                id="job_title_id"
                v-model="form.job_title_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name"
                ep="v2/selects/job-titles"
                disabled 
                
              />
            </b-col>
            <b-col ols="12">
              
              <form-cleave
                v-model="form.phone_number"
                rules="required"
                label=" رقم الموبايل"
                isNumber
                :charsCount="10"
              />
            </b-col>
            
            <b-col cols="12">
              <form-mask
                label="تاريخ الميلاد"
                id="dob"
                v-model="form.dob"
                :raw="false"
                placeholder="YYYY-MM-DD"
                options="date"
                rules="required"
              />
            </b-col>
            <b-col>
              <form-cleave
                label="الرقم الوطني"
                v-model="form.ID_number"
                isNumber
                :charsCount="11"
                rules="required|min:11"
              />
              <small class="text-danger" v-if="isTrue"> يوجد عضو يحمل هذا الرقم الوطني </small>
            </b-col>
            <b-col cols="12">
              <form-file-input
                placeholder="اختر ملفاً"
                id="document"
                label="نشرة الإستعلام"
                accept=".pdf"
                v-model="form.inquiry_bulletin_file"
                rules="required"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  
} from "bootstrap-vue";
import axios from "@axios";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import FormCleave from "@/components/FormCleave.vue";
import FormTextarea from "@/components/form-textarea/index.vue";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    FormCleave ,
    FormTextarea,
    FormFileInput
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "بيانات معاملة",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
      govId: null,
      isTrue : false
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
    // form: {
    //   handler: async function(newVal, oldVal) {
    //     if(newVal.ID_number && newVal.ID_number.length === 11){
    //       await axios.post(`v2/check-director-Id-number`, {
    //         ID_number: newVal.ID_number
    //       })
    //       .then((res) => this.isTrue = res.data.data);
    //     }
    //     else{
    //       this.isTrue = false
    //     }
    //   },
    //   deep: true
    // },
    async 'form.ID_number'() {
      if(this.form.ID_number && this.form.ID_number.length === 11){
        await axios.post(`v2/check-director-Id-number`, {
          ID_number: this.form.ID_number
        })
        .then((res) => this.isTrue = res.data.data);
      }
      else{
        this.isTrue = false
      }
    },
    'form.old_director_id'() {
      if(this.form.old_director_id.hasOwnProperty('jobTitle')){
        this.form.job_title_id = this.form.old_director_id.jobTitle
      }
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          if(this.form.old_director_id.hasOwnProperty('director_board_id')){
            this.form.director_board_id = {id:this.form.old_director_id.director_board_id , name_ar : null}
          }
          if(this.isTrue === false){

            this.$emit("confirm", this.form);
          }
        }
      });
    },
  },
};
</script>
